/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconSpeechBubbles: {
  name: 'speech_bubbles';
  data: string;
} = {
  name: 'speech_bubbles',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M537.081 498.131c29.817-20.221 48.307-48.328 48.307-79.411 0-61.58-72.553-111.503-162.059-111.503S261.267 357.139 261.267 418.72s72.559 111.503 162.062 111.503c21.794 0 42.578-2.967 61.56-8.335l81.908 61.142-29.716-84.899zM470.274 164.588c0-70.812-97.458-128.219-217.677-128.219S34.92 93.772 34.92 164.588c0 33.315 21.573 63.659 56.934 86.458L57.549 390.989l117.97-106.46c23.962 5.346 49.936 8.281 77.078 8.281 120.219 0 217.677-57.406 217.677-128.222z"/></svg>`,
};
